<template>
  <div class="description text-left">
    <span class="text" v-html="htmlPersonalization ? (completeText ? text : shortText) : 
                               formatText(completeText ? text : shortText)">
    </span>
    <button
      v-if="textSize > maxWords"
      class="show-more-text"
      @click="showMoreAction"
    >
      {{ completeText ? $t("wegow.showLess") : $t("wegow.showMore") }}
    </button>
  </div>
</template>
<script setup>
import { toRefs, computed, ref } from "vue";
import { defineProps } from 'vue';

const props = defineProps({
  text: {
    type: String,
    default: undefined
  },
  maxWords: {
    type: Number,
    default: 80
  },
  htmlPersonalization: {
    type: Boolean,
    default: false
  },
});
const { text, maxWords } = toRefs(props);

const completeText = ref(false);
const textSize = computed(() => text.value?.split(" ").length);
const shortText = computed(() => {
  const wordsList = text.value?.split(" ");

  return textSize.value > maxWords.value
    ? wordsList.splice(0, maxWords.value).join(" ") + "..."
    : text.value;
});

const showMoreAction = () => {
  completeText.value = !completeText.value;
  if (!completeText.value) {
    const description = document.getElementById("description");
    description.scrollIntoView({ behavior: "smooth" });
  }
};

const formatText = text => {
  return text?.replace(/\n/g, "<br>");
};
</script>
<style lang="scss">
.description{
  color: $descriptionColor;
  font-weight:400;
  font-size: 16px;
  .show-more-text{
    color: $showMoreColor;
  }
}
</style>
